import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { User } from 'src/app/_models/user';
import { Router } from '@angular/router';
import { BlogService } from 'src/app/_services/blog.service';
import { ProductCategoryService } from 'src/app/_services/product-category.service';
import { ProductCategory } from 'src/app/_models/product-category';


@Component({
    selector: 'app-add-blog-post',
    templateUrl: './add-blog-post.component.html',
    styleUrls: ['./add-blog-post.component.css'],
    standalone: false
})
export class AddBlogPostComponent implements OnInit {
  title = 'Add new post';
  form: UntypedFormGroup;
  user: User = null;
  categories: ProductCategory[] = [];
  loading = true;
  submitting = false;
  selectedFile = null;
  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private blogService: BlogService,
     private categoryService: ProductCategoryService) {
    this.user = JSON.parse(localStorage.getItem('currentUser') ?? '{}');
  }

  ngOnInit() {
    if (!this.user?.id) {
      this.router.navigate(['/signin']);
      return;
    }

    this.buildForm();

    this.categoryService.get_product_categories().subscribe({
      next: (categories: ProductCategory[]) => {
        this.categories = categories;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  private buildForm() {
    this.form = this.fb.group({
      userId: new UntypedFormControl(this.user.id),
      name: new UntypedFormControl(this.user.firstName + ' ' + this.user.lastName),
      body: new UntypedFormControl('', [Validators.required]),
      title: new UntypedFormControl('', [Validators.required]),
      categoryId: new UntypedFormControl('', [Validators.required]),
      picture: new UntypedFormControl('', [Validators.required]),
    });
  }

  onSelectedPicture(event) {
    this.selectedFile = event.target.files[0];
  }

  publishPostBlog() {
    this.submitting = true;
    this.blogService.addBlogPost(this.form.value, this.selectedFile).subscribe(
      () => this.form.reset(),
      () => { this.submitting = false; },
      () => this.router.navigateByUrl('/blog')
    );
  }

}
